export const colors = {
    main: '#65bc7b',
    selected: '#e8501f',
    navSelected: '#282c34',
    buttonHover:  'black',
    cancel:  '#44a9db',
}
